// @flow
import { formatValue } from '../../../../lib/usage-formatters';

const formatValues = (currentValue: number, maxValue: number) => ({
  current: formatValue(currentValue, 'MONETARY'),
  max: formatValue(maxValue, 'MONETARY'),
});

export default formatValues;
